import React, { useEffect } from 'react';
import './logout-page.css'
import './signing.css'
import Logo from '../../assets/admin/HFH-logo.svg';
//import LogoImages from '../../assets/hearts-for-hearing-logo-white.png';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { useMsal } from '@azure/msal-react';
import { logoutRequest } from '../../authConfig';
import { logoutUser } from '../../store/auth';

const Logout = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const { instance } = useMsal();

    useEffect(() => {
        dispatch(logoutUser());

        const activeAccount = instance.getActiveAccount() || instance.getAllAccounts()[0];
        if (activeAccount) {
            fetch('/auth/logout', { method: 'POST', credentials: 'include' })
                .catch((error) => console.log('[Logout] Local logout error:', error))
                .finally(() => {
                    instance.logoutRedirect({
                        ...logoutRequest,
                        account: activeAccount
                    }).catch((error) => console.log(error));
                });
        }
    }, []);
    return (
        <>
            <section>
                <div className="login-splash-wrap">
                    <div className="login-splash-section">
                        <img src={Logo} alt="logo" className="logo" />
                        <div>
                            <p className="login-splash-content">You are logged out</p>
                            <button className="login-splash-btn" onClick={() => navigate('/login?backtologin=true')}>Login</button>
                        </div>
                    </div>
                </div>
            </section>
            
        </>
    );
};

Logout.propTypes = {
};

export default Logout;